module.exports = __webpack_public_path__ + "images/help/video-preview-me-d19bc7e2e6f4e56cf469d14193123f1f.jpg";